/*

--------------------------------------------------------------------------------
Oriflame dropdown date picker ( "birthdate" picker )
--------------------------------------------------------------------------------

Doesn't use calendar widget as a popup like the default Kendo date pickers,
but 3 dropdowns instead to select day, month & year separatelly.

Want to send 1 value only, so only 1 hidden input with name for the date value is present.
The dropdowns' values will not be sent to server as their inputs don't have names set.

Dependency list :
jquery.js
kendo.core.js
ori.kendo.core.js
? kendo.data.js
kendo.popup.js
kendo.list.js
ori.kendo.dropdowndatepicker.js

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo,
        ui = kendo.ui,
        Widget = ui.Widget,
        ComboBox = ui.ComboBox,
        parse = kendo.parseDate,
        extractFormat = kendo._extractFormat,
        DAY = "day",
        MONTH = "month",
        YEAR = "year",
        SPAN = "<span />",
        CHANGE = "change",
        COMBO_CHANGE = "comboChange",
        WIDGET = ".k-widget",
        INPUT = "k-input",
        INPUT_MARKUP = '<input type="text" />',
        COMPONENT_CLASS = "k-dropdown-datepicker",
        DROP_DOWN_PICKER = "DropDownDatePicker",
        NS = ".kendo" + DROP_DOWN_PICKER,
        CLOSE = "close",
        OPEN = "open",
        HOVER_EVENTS = "mouseenter" + NS + " " + "mouseleave" + NS,
        FOCUS_EVENT = "focus" + NS,
        FORM_RESET = "reset",
        STATE_DEFAULT = "k-state-default",
        STATE_HOVER = "k-state-hover",
        STATE_DISABLED = "k-state-disabled",
        HIDDEN = "hidden",
        INVISIBLE = "invisible",
        AVATAR = "avatar",
        ATTR_TAB_INDEX = "tabindex",
        TITLE = "title",
        ARIA_HIDDEN = "aria-hidden",
        ARIA_VALUE_NOW = "aria-valuenow",
        DEFAULT_MIN_DATE = new Date(1900, 0, 1),
        DEFAULT_MAX_DATE = new Date(2099, 11, 31),
        proxy = $.proxy,
        dropDownTypes = [YEAR, MONTH, DAY],
        placeholders = (function () {
            var result = {};
            result[DAY] = "Day";
            result[MONTH] = "Month";
            result[YEAR] = "Year";
            return result;
        })(),
        TODAY = new Date(),
        MAX_DAYS = 31,
        MAX_MONTH = 12, // 1-based here
        DEFAULT_ORDER_FORMAT = "dMy";

    TODAY = new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate(), 0, 0, 0);

    function normalize(options) {
        options = options || {};
        var culture = kendo.getCulture(options.culture);
        options.format = extractFormat(options.format || culture.calendars.standard.patterns.d);
        var parseFormats = options.parseFormats,
            format = options.format;
        parseFormats = $.isArray(parseFormats) ? parseFormats : [parseFormats];
        if (!parseFormats.length) parseFormats.push("yyyy-MM-dd");
        if ($.inArray(format, parseFormats) === -1) parseFormats.splice(0, 0, options.format);
        options.parseFormats = parseFormats;
    }

    function restrictValue(value, min, max) {
        var result = TODAY;
        if (value) result = new Date(+value);
        if (min > result)
            result = new Date(+min);
        else if (max < result)
            result = new Date(+max);
        return result;
    }

    function isInRange(date, min, max) {
        return +date >= +min && +date <= +max;
    }

    function fixComboValue(value) {
        return $.isNumeric(value) ? +value : null;
    }

    function isEqualDatePart(value1, value2) {
        if (value1) {
            return value1.getFullYear() === value2.getFullYear() &&
                value1.getMonth() === value2.getMonth() &&
                value1.getDate() === value2.getDate();
        }
        return false;
    }

    function getMonthNumbers() {
        return ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
    }

    var DropDownDatePicker = Widget.extend({

        init: function (element, options) {
            var self = this;
            Widget.fn.init.call(self, element, options);
            element = self.element
                .addClass([INPUT, INVISIBLE].join(" ") /* TODO : HIDDEN ? */)
                .attr(ATTR_TAB_INDEX, -1)
                .attr(ARIA_HIDDEN, "true")
                .attr("autocomplete", "off")
                .on(FOCUS_EVENT, proxy(self._focusin, self))
                .attr("role", "dropdowndatepicker");
            options = self.options;
            options.min = parse(element.attr("min")) || parse(options.min);
            options.max = parse(element.attr("max")) || parse(options.max);
            normalize(options);
            // remember title text - needed for various description UI types
            self.options.titleText = self.options.titleText || element.attr(TITLE);
            element
                .removeAttr(TITLE)
                .removeClass(AVATAR);
            self._wrapper();
            self._dropDowns();
            self._reset();
            Widget.fn.descriptionUi.call(self);
            var value = self.options.value;
            self.value(value !== null ? value : element.val());

            var isEnabled = !element.is("[disabled]");
            self.enable(isEnabled);
            if (isEnabled) {
                self.readonly(element.is("[readonly]"));
            }
            kendo.notify(self);
        },

        options: kendo.getUpdatedWidgetOptions({
            name: DROP_DOWN_PICKER,
            value: null,
            format: "",
            culture: "",
            parseFormats: [],
            min: DEFAULT_MIN_DATE,
            max: DEFAULT_MAX_DATE,
            placeholders: placeholders,
            orderDropDownsByFormat: false,
            orderFormat: "",
            useMonthNumbersAsNames: false
        }),

        events: [
            COMBO_CHANGE,
            CHANGE,
            OPEN,
            CLOSE
        ],

        _editable: function (options) {
            var self = this,
                element = self.element, // .off( NS ),
                wrapper = self.wrapper, // .off( NS ),
                readonly = options.readonly,
                disable = options.disable,
                i, l;
            if (!readonly && !disable) {
                wrapper
                    .addClass(STATE_DEFAULT)
                    .removeClass(STATE_DISABLED)
                    .on(HOVER_EVENTS, self._toggleHover);
                element
                    .on(FOCUS_EVENT, proxy(self._focusin, self));
            } else {
                wrapper
                    .addClass(disable ? STATE_DISABLED : STATE_DEFAULT)
                    .removeClass(disable ? STATE_DEFAULT : STATE_DISABLED)
                    .off(HOVER_EVENTS, self._toggleHover);
                element
                    .off(FOCUS_EVENT);
            }
            for (i = 0, l = dropDownTypes.length; i < l; i++) {
                var combo = self[dropDownTypes[i]];
                combo.enable(!disable);
                if (!disable) {
                    combo.readonly(readonly);
                }
            }
        },

        readonly: function (value) {
            this._editable({
                readonly: value === undefined ? true : value,
                disable: false
            });
        },

        enable: function (value) {
            this._editable({
                readonly: false,
                disable: !(value === undefined ? true : value)
            });
        },

        /**
         * Destroys the widget.
         */
        destroy: function () {
            var self = this;
            self.element
                .add(self.wrapper)
                .off(NS);
            for (var i = 0, l = dropDownTypes.length; i < l; i++) {
                var combo = self[dropDownTypes[i]];
                combo.element
                    .add(combo.wrapper)
                    .off();
                combo.destroy();
            }
            if (self._form) self._form.off(FORM_RESET, self._resetHandler);
            Widget.fn.destroy.call(self);
            self.info("Destroyed widget bound to %s.", self.describeElement(self.element));
        },

        /**
         * Public getter / setter of the whole component's value.
         */
        value: function (value) {
            var self = this;
            if (value === undefined) return self._value;
            self._update(value);
            self._old = self._value;
        },

        isEmpty: function () {
            var self = this;
            return self.day.value() === "" && self.month.value() === "" && self.year.value() === "";
        },

        /**
         * Creates the dropdown subcomponents.
         */
        _dropDowns: function () {
            var self = this,
                opt = self.options,
                format = DEFAULT_ORDER_FORMAT,
                defaults = [
                    { type: YEAR, pattern: "y" },
                    { type: MONTH, pattern: "M" },
                    { type: DAY, pattern: "d" }
                ],
                i, l = dropDownTypes.length;

            if (opt.orderDropDownsByFormat) {
                format = (opt.orderFormat && opt.orderFormat.length > 0) ? opt.orderFormat : (opt.format || "");
            }

            function checkFormat(format) {
                var result = defaults;
                // store found positions & exit when some part was not found
                for (var i = 0; i < l; i++) {
                    var p;
                    for (var j = 0; j < l; j++) {
                        p = result[j];
                        if (p.type === dropDownTypes[i]) break;
                    }
                    // TODO : just a very stupid search for the format tokens for day, month & year here - better ?
                    p.position = format.indexOf(p.pattern);
                    if (p.position < 0) return false;
                }
                // order result according to found indexes
                result.sort(function (a, b) {
                    return a.position - b.position;
                });
                return result;
            }

            // create the dropdowns if some don't exist yet
            for (i = 0; i < l; i++)
                if (!self[dropDownTypes[i]]) {
                    // var dropDown = new ComboBox(
                    var dropDown = new ComboBox(
                        $(INPUT_MARKUP),
                        {
                            dataTextField: "label",
                            dataValueField: "value",
                            filter: "contains",
                            suggest: true,
                            placeholder: self.options.placeholders[dropDownTypes[i]],
                            change: proxy(self._change, self),
                            open: proxy(self._open, self),
                            close: proxy(self._close, self)
                        }
                    );
                    self[dropDownTypes[i]] = dropDown;
                    // dropDown.element.on( BLUR_EVENT, proxy( self._focusout, self ) );
                    dropDown.wrapper.addClass("k-" + dropDownTypes[i]);
                    self.info("Created dropdown for %s.", dropDownTypes[i]);
                }
            // insert into whole component
            // check current ( possibly custom ) format
            var positions = checkFormat(format);
            // get default culture format if needed
            if (!positions) {
                self.info("Can't order dropdowns according to current format '%s', setting default culture format.", format);
                var culture = kendo.getCulture(options.culture);
                format = culture.calendars.standard.patterns.d;
                positions = checkFormat(format);
            }
            // order with default dummy format if previous didn't work
            if (!positions) {
                format = DEFAULT_ORDER_FORMAT;
                positions = checkFormat(format);
            }
            // prepending to whole component's wrapper, this way able to reorder anytime
            var s = [];
            for (i = l - 1; i >= 0; i--) {
                // self.wrapper.prepend( self[ positions[ i ].type ].wrapper );
                // keep self.element the first child due to current kendo.findWidgetInstance() implementation
                self[positions[i].type].wrapper.insertAfter(self.element);
                s.unshift(positions[i].type);
            }
            self.info("Dropdowns inserted in order %s.", s.join(", "));
        },

        _focusin: function (event) {
            var self = this,
                active = document.activeElement;
            self.info("_focusin(), event : %o, active : %s", event, self.describeElement(active));
            // self.wrapper.addClass( STATE_FOCUSED ); // TODO : keep this or is focus state on combos enough ...
            if (
                active === self.day.element[0] ||
                active === self.month.element[0] ||
                active === self.year.element[0]
            ) return;
            // event.preventDefault();
            clearTimeout(self._focusTimeout);
            self._focusTimeout = setTimeout(function () {
                var instance = self.wrapper.first(WIDGET);
                if (!instance) return;
                instance = kendo.findWidgetInstance(instance);
                if (!instance) return;
                self.info("_focusin() timeout callback, focusing first combobox field ...");
                instance.focus();
            }, 0);
        },

        _focusout: function (event) {
            var self = this;
            if (event.delayedDispatch) { // re-caught the delayed event - just allow its bubbling further
                // it should not even get here but to be safe, better check this before endlessly re-triggering the same event
                return true;
            }
            var delayedEvent = $.extend({ delayedDispatch: true }, event);
            event.stopPropagation();
            setTimeout(function () { // delayed event dispatch
                var $datePicker = $(document.activeElement).closest("." + COMPONENT_CLASS),
                    widget = kendo.findWidgetInstance($datePicker);
                if (widget !== self) { // the focus is not in the same datepicker => dispatch focusout further, thus triggering validation
                    self.wrapper.parent().trigger(delayedEvent);
                }
            });
        },

        /**
         * Used for updating datasources of combo subcomponents according to current selected values.
         * 
         * If there's only 1 of the 3 combo values set, there can be set limit on year
         * according to max / min options, months are unfiltered & days are filtered only when month
         * is selected and value is 1 ( February ).
         * 
         * If there are 2 ( or all 3 ) of the 3 values set, the 3rd datasource can be limited precisely.
         * 
         * @param {} dropDownType Says for which component we want to get the maximum allowed datasource value.
         * @param {} day Current day component value.
         * @param {} month Current month component value, 1-based here.
         * @param {} year Current year component value.
         * @param {} min Minimum date value allowed to be selected by the whole component from options.
         * @returns {} 
         */
        _minComponentValue: function (dropDownType, year, month, day, min) {
            var self = this,
                d, l;
            day = fixComboValue(day);
            month = fixComboValue(month);
            year = fixComboValue(year);
            switch (dropDownType) {
                case DAY:
                    // without known month or year just return the miminum possible day
                    if (!$.isNumeric(month) || !$.isNumeric(year)) return 1;
                    // most precise count from both year & month
                    d = new Date(year, month, 0, 0, 0, 0, 0);
                    for (day = 1, l = d.getDate(); day <= l; day++) {
                        d = new Date(year, month - 1, day, 0, 0, 0, 0);
                        if (+d >= +min) return d.getDate();
                    }
                    break;
                case MONTH:
                    // months are 0-based in JS
                    // without known year just return the minimum possible month
                    if (!$.isNumeric(year)) return 1;
                    // with known year but unknown day just set highest possible day in month for checking
                    // this has to be determined first for a given month
                    var haveDay = $.isNumeric(day);
                    for (month = 1; month <= MAX_MONTH; month++) {
                        // get max day for month first when not known
                        if (!haveDay) {
                            d = new Date(year, month, 0, 0, 0, 0, 0);
                            day = d.getDate();
                        }
                        d = new Date(year, month - 1, day, 0, 0, 0, 0);
                        if (+d >= +min) return month;
                    }
                    break;
                case YEAR:
                    // without known month just return the year according to max
                    year = min.getFullYear();
                    if (!$.isNumeric(month)) return year;
                    // with known month but unknown day just set highest possible day in month for checking
                    if (!$.isNumeric(day)) {
                        d = new Date(year, month, 0, 0, 0, 0, 0);
                        day = d.getDate();
                    }
                    d = new Date(year, month - 1, day, 0, 0, 0, 0);
                    if (+d < +min) year++;
                    return year;
                    break;
            }
            self.warning(
                "Couldn't find min component value for given parameters :\n" +
                "\t dropDownType : %s, day : %s, month : %s, year : %s, min : %o",
                dropDownType, day, month, year, min
            );
            return null;
        },

        /**
         * Used for updating datasources of combo subcomponents according to current selected values.
         * 
         * If there's only 1 of the 3 combo values set, there can be set limit on year
         * according to max / min options, months are unfiltered & days are filtered only when month
         * is selected and value is 1 ( February ).
         * 
         * If there are 2 ( or all 3 ) of the 3 values set, the 3rd datasource can be limited precisely.
         * 
         * @param {} dropDownType Says for which component we want to get the maximum allowed datasource value.
         * @param {} day Current day component value.
         * @param {} month Current month component value, 1-based here.
         * @param {} year Current year component value.
         * @param {} max Maximum date value allowed to be selected by the whole component from options.
         * @returns {} 
         */
        _maxComponentValue: function (dropDownType, year, month, day, max) {
            var self = this,
                d;
            day = fixComboValue(day);
            month = fixComboValue(month);
            year = fixComboValue(year);
            switch (dropDownType) {
                case DAY:
                    // without known month just return the maximum possible days per month
                    if (!$.isNumeric(month)) return MAX_DAYS;
                    // with known month but unknown year use the fixed days per month in Gregorian calendar
                    // for February in this case use maximum possible for a leap year (  29 )
                    if (!$.isNumeric(year)) {
                        switch (month) {
                            case 2: return 29;
                            case 4, 6, 9, 11: return 30;
                            default: return MAX_DAYS;
                        }
                    }
                    // most precise count from both year & month
                    d = new Date(year, month, 0, 0, 0, 0, 0);
                    for (day = d.getDate(); day > 0; day--) {
                        d = new Date(year, month - 1, day, 0, 0, 0, 0);
                        if (+d <= +max) return d.getDate();
                    }
                    break;
                case MONTH:
                    // months are 0-based in JS
                    // without known year just return the maximum possible month
                    if (!$.isNumeric(year)) return MAX_MONTH;
                    // with known year but unknown day just set lowest possible day in month ( 1 ) for checking
                    if (!$.isNumeric(day)) day = 1;
                    for (month = MAX_MONTH; month > 0; month--) {
                        d = new Date(year, month - 1, day, 0, 0, 0, 0);
                        if (+d <= +max) return month;
                    }
                    break;
                case YEAR:
                    // without known month just return the year according to max
                    year = max.getFullYear();
                    if (!$.isNumeric(month)) return year;
                    // with known month but unknown day just set lowest possible day in month ( 1 ) for checking
                    if (!$.isNumeric(day)) day = 1;
                    d = new Date(year, month - 1, day, 0, 0, 0, 0);
                    if (+d > +max) year--;
                    return year;
                    break;
            }
            self.warning(
                "Couldn't find max component value for given parameters :\n" +
                "\t dropDownType : %s, day : %s, month : %s, year : %s, max : %o",
                dropDownType, day, month, year, max
            );
            return null;
        },

        _prepareDataSource: function (dropDownType) {
            if (dropDownType !== DAY && dropDownType !== MONTH && dropDownType !== YEAR) return null;
            var self = this,
                result = [],
                currentValue = self.value(), i,
                min = self.options.min || DEFAULT_MIN_DATE,
                max = self.options.max || DEFAULT_MAX_DATE,
                isDate = currentValue && currentValue instanceof Date,
                day = isDate ? currentValue.getDate() : (self.day ? fixComboValue(self.day.value()) : null),
                month = isDate ? currentValue.getMonth() + 1 : (self.month ? fixComboValue(self.month.value()) : null),
                year = isDate ? currentValue.getFullYear() : (self.year ? fixComboValue(self.year.value()) : null),
                minValue = self._minComponentValue(dropDownType, year, month, day, min),
                maxValue = self._maxComponentValue(dropDownType, year, month, day, max);
            switch (dropDownType) {
                case DAY:
                    for (i = minValue; i <= maxValue; i++)
                        result.push({ value: i, label: i.toString() });
                    break;
                case MONTH:
                    // TODO : possibly we should set variable translated labels according to formatting & culture
                    var culture = kendo.getCulture(self.options.culture);
                    var months = self.options.useMonthNumbersAsNames ? getMonthNumbers() : culture.calendar.months.names;
                    // month component value is 1-based, but month evaluation in dates in JS is 0-based
                    for (i = minValue; i <= maxValue; i++)
                        result.push({ value: i, label: months[i - 1] });
                    break;
                case YEAR:
                    for (i = maxValue; i >= minValue; i--)
                        result.push({ value: i, label: i.toString() });
                    break;
            }
            var l = result.length;
            self.info(
                "Updating datasource for %s combo, count : %s, first item : %s, last item : %s ...",
                dropDownType, l, l ? result[0].label : null, l ? result[l - 1].label : null
            );
            return result;
        },

        /* TODO : really needed ? */
        _toggleHover: function (event) {
            $(event.currentTarget).toggleClass(STATE_HOVER, event.type === "mouseenter");
        },

        /**
         * Sets the main component's value while optionally also correcting
         * the particular combo subcomponents' values.
         * @param {} value New value to be set.
         * @param {} lastTrigger Last combo which triggered the change. When set it means
         * self the change was not triggered programmatically & corresponding event should
         * be triggered, too.
         */
        _update: function (value, lastTrigger) {
            var self = this,
                oldValue = self._value,
                options = self.options,
                min = options.min,
                max = options.max,
                current = self._value,
                result = parse(value, options.parseFormats, options.culture),
                isSameType = (result === null && current === null) || (result instanceof Date && current instanceof Date),
                formattedValue;
            if (+result === +current && isSameType) {
                formattedValue = kendo.toString(result, options.format, options.culture);
                if (formattedValue !== value) self.element.val(result === null ? value : formattedValue);
                return result;
            }
            if (result !== null && isEqualDatePart(result, min))
                result = restrictValue(result, min, max);
            else if (!isInRange(result, min, max))
                result = null;
            self._value = result;
            var isDate = result && result instanceof Date;
            if (lastTrigger && !isDate) {
                // when the new component value is null & we know the combo which did the last update,
                // reset only this component's value & don't touch the current values of other combos
                lastTrigger.value(null);
            } else {
                // TODO : or when not wanted, we could actually keep the current values in combos
                // and not reset them when isDate === false
                self.day.value(isDate ? result.getDate() : null);
                self.month.value(isDate ? result.getMonth() + 1 : null);
                self.year.value(isDate ? result.getFullYear() : null);
            }
            // update combos' data sources
            for (var i = 0, l = dropDownTypes.length; i < l; i++)
                self[dropDownTypes[i]].setDataSource(self._prepareDataSource(dropDownTypes[i]));
            // set the whole component's value into the hidden input field
            self.element.val(isDate ? kendo.toString(result, options.format, options.culture) : value);
            self.element.attr(ARIA_VALUE_NOW, result); // TODO : or formatted value ?
            // TODO : limit here only to lastTrigger ( combobox change which caused whole component change ) ?
            // means for now no event will be triggered when value was set programmatically
            if (lastTrigger && oldValue !== self._value) self._dispatchEvent(CHANGE);
            return result;
        },

        _dispatchEvent: function (type, data) {
            var self = this;
            self.info("Triggering %s event ...", type);
            self.element.trigger(type, data);
            self.trigger(type, data);
        },

        /**
         * Returns widget instance object for the combo which triggered last event.
         */
        _eventInstance: function (event) {
            return (event && event.sender && event.sender.element) ?
                kendo.findWidgetInstance(event.sender.element) : null;
        },

        /**
         * Returns string type of the combo which triggered last event. 
         */
        _instanceType: function (instance) {
            var self = this;
            if (self.day === instance) return DAY;
            if (self.month === instance) return MONTH;
            if (self.year === instance) return YEAR;
            return null;
        },

        /**
         * Partial combobox change event handler.
         */
        _change: function (event) {
            var self = this,
                max = self.options.max || DEFAULT_MAX_DATE,
                newValue = null,
                oldValue = self._value, // old value of the whole component
                instance = self._eventInstance(event),
                instanceType = self._instanceType(instance),
                instanceValue = instance ? instance.value() : null,
                day = fixComboValue(self.day.value()),
                month = fixComboValue(self.month.value()), // 1-based here
                year = fixComboValue(self.year.value());

            function sameValues(v1, v2) {
                return ((v1 === null ? "" : v1).toString() === v2);
            };

            // trigger combo changed event
            self._dispatchEvent(COMBO_CHANGE, { which: instanceType });

            if (day < 1 || day > MAX_DAYS) day = null; // day = MAX_DAYS;
            if (month < 1 || month > MAX_MONTH) month = null; // month = MAX_MONTH;
            // TODO : only this check for ranges here or complete checks for min / max on all dropdowns ?
            var days = self._maxComponentValue(DAY, year, month, day, max);
            if (day > days) day = days;
            self.info(
                "_updateValue()\n" +
                "\t event : %o, oldValue : %o, instance : %o, instanceValue : %s, instanceType : %s\n" +
                "\t day : %s, month : %s, year : %s, days : %s",
                event, oldValue, instance, instanceValue, instanceType,
                day, month, year, days
            );
            if (!sameValues(day, self.day.value())) {
                self.day.value(day);
                self.info("Corrected day to %s.", day);
            }
            if (!sameValues(month, self.month.value())) {
                self.month.value(month);
                self.info("Corrected month to %s.", month);
            }
            if (!sameValues(year, self.year.value())) {
                self.year.value(year);
                self.info("Corrected year to %s.", year);
            }
            // check whether we can compose a proper new date from the three comboboxes
            if (day !== null && month !== null && year !== null)
                try {
                    newValue = new Date(year, month - 1, day, 0, 0, 0, 0);
                } catch (error) {
                    self.info(
                        "Couldn't compose a valid date from current values, day : %s, month : %s, year : %s",
                        day, month, year
                    );
                }
            self.info("New whole component value : %o", newValue);
            self._update(newValue, instance);
        },

        /**
         * Triggers combo open event.
         * For some reason scrolling the selected item into view doesn't work,
         * so let's do it manually here, too.
         * TODO : better ?
         */
        _open: function (event) {
            var self = this,
                instance = self._eventInstance(event),
                instanceType = self._instanceType(instance);
            // $current = $( instance && typeof instance.current == "function" ? instance.current() : null );
            // TODO : now this seems to work, so keeping just for case to not invent it again later ...
            // show the selected item if possible
            //if( $current.length ) {
            //    setTimeout( function() {
            //        instance.listView.scroll( $current );
            //    }, 0 );
            //}
            // dispatch the event for other listeners
            self._dispatchEvent(OPEN, { which: instanceType });
        },

        /**
         * Triggers combo close event.
         */
        _close: function (event) {
            var self = this,
                instance = self._eventInstance(event),
                instanceType = self._instanceType(instance);
            self._dispatchEvent(CLOSE, { which: instanceType });
        },

        _reset: function () {
            var self = this,
                $element = self.element,
                $form = $element.closest("form");
            if ($form[0]) {
                self._resetHandler = function () {
                    setTimeout(function () {
                        self.value($element[0].value);
                    });
                };
                self._form = $form.on(FORM_RESET, self._resetHandler);
            }
        },

        _wrapper: function () {
            var self = this,
                $element = self.element,
                $wrapper;
            $wrapper = $element.parents("." + COMPONENT_CLASS);
            if (!$wrapper.length)
                $wrapper = $element.wrap(SPAN).parent();
            self.wrapper = $wrapper
                .addClass(["k-widget", "k-header", STATE_DEFAULT, COMPONENT_CLASS].join(" "))
                .addClass($element[0].className)
                .removeClass([HIDDEN, INVISIBLE, AVATAR, INPUT].join(" "))
                .attr(ATTR_TAB_INDEX, -1)
                .attr("role", "presentation")
                .on("focusout", proxy(self._focusout, self));
        }

    });

    ui.plugin(DropDownDatePicker);

})(window.kendo.jQuery);
